import type { SearchParams } from '../types'

// TODO it doesn't work with arrays - added on 2021-12-22 by maddoger
export const getSearchParams = (search) => {
  const params = {}

  new URLSearchParams(search).forEach((value, key) => {
    params[key] = value
  })

  return params
}

export const mergeSearchParams = (url: string, searchParams: SearchParams | string) => {// me
  const match = url.match(/^(.*?)(|\?.*?)$/)
  const pathname = match[1]
  const params = new URLSearchParams(match[2])
  // TODO check if it works with arrays - added on 2022-02-22 by maddoger
  // @ts-ignore
  const newParams = new URLSearchParams(searchParams)

  newParams.forEach((value, name) => {
    if (value !== undefined && value !== null && typeof value !== 'undefined' && value !== 'undefined' && value !== 'null') {
      params.set(name, value)
    }
    else {
      params.delete(name)
    }
  })

  // delete redirect param if we're already on it
  if (params.has('redirect') && params.get('redirect') === pathname) {
    params.delete('redirect')
  }

  // delete tokens from redirect url for security reasons
  // params.delete('ltn') // keep for sentry
  // params.delete('magicToken')

  // replace `?` without params
  return `${pathname}?${params.toString()}`.replace(/\?$/, '')
}


export default getSearchParams
